import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { PaginatedColocApiConnectedDropDown } from '@/features/shared/feature-paginated-coloc-api-connected-dropdown';

import { House } from '@/types/admin';
import { useGetHousesInfinite } from '@/features/shared/hooks/use-get-houses-infinite';
import { useStatsFiltersContext } from '../../hooks/use-stats-filters';

const StatsHouseSelectionDropDown = () => {
  const { selectedHouse, setSelectedHouse, housesQuery, setHousesQuery } = useStatsFiltersContext();
  const { t } = useTranslation();

  return (
    <PaginatedColocApiConnectedDropDown<House>
      placeholder={t('js.features.admin.stats.dashboard.house_selection.placeholder')}
      className="w-full max-w-[200px]"
      showLabel
      label={t('js.features.admin.stats.dashboard.house_selection.label')}
      value={selectedHouse}
      onChange={setSelectedHouse}
      {...(selectedHouse && {
        displayValue: selectedHouse.name,
      })}
      onTextInputChange={(event) => setHousesQuery(event.target.value)}
      dataSource={
        useGetHousesInfinite({
          searchQuery: housesQuery,
        })!
      }
      itemRenderer={(itemProps, ref) => {
        return (
          // @ts-ignore
          <DropDown.DropDownOptionDefaultContent
            ref={ref}
            className="font-['sofia-pro'] text-sm font-normal leading-[21px] text-[#212529]"
          >
            {itemProps.name}
          </DropDown.DropDownOptionDefaultContent>
        );
      }}
    />
  );
};

export { StatsHouseSelectionDropDown };
